import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import Message from '@zr/components/zrs/Message';

import {
  STRING_SCREEN_NO_MORE,
  STRING_SCREEN_ADD_ANOTHER,
  STRING_SCREEN_EXPERIENCE_ADD_ANOTHER_SUCCESS,
} from '@zr/jobseeker-public/apps/jobseeker-screens/labels';

import ExperienceFieldset from '@zr/jobseeker-public/apps/profile-form/components/Formik/ExperienceFieldset';

import {
  // these fields aren't profile jso fields, but are transformed into the profile date fields
  validationSchema,
  initialValues,
} from '@zr/jobseeker-public/apps/profile-form/utilities/experienceFormUtilities';

import areTextInputsEmpty from '@zr/jobseeker-public/apps/profile-form/utilities/areTextInputsEmpty';

import './ScreenViewWrapper.less';
import './WorkExperience.less';

export default function WorkExperienceForm({
  enableReinitialize,
  enableRichText,
  disabled,
  handleFormSubmit,
  numExperiencesAdded,
  onContinue,
  overrideInitialValues,
  setAddAnother,
  setNoMore,
  stringAddAnother,
  stringNoMore,
}) {
  return (
    <Formik
      enableReinitialize={enableReinitialize}
      initialValues={overrideInitialValues}
      onSubmit={handleFormSubmit}
      validationSchema={validationSchema}
    >
      {(formikProps) => {
        const {
          handleSubmit, isSubmitting, values,
        } = formikProps;

        return (
          <form className="ScreenViewWrapper WorkExperience" onSubmit={handleSubmit}>
            {numExperiencesAdded > 0 && (
              <Message type="success">{STRING_SCREEN_EXPERIENCE_ADD_ANOTHER_SUCCESS}</Message>
            )}
            <ExperienceFieldset
              disabled={disabled}
              formikProps={formikProps}
              numAdded={numExperiencesAdded}
              enableRichText={enableRichText}
            />
            <div className="button_wrapper">
              <button
                className="primary_button"
                onClick={setAddAnother}
                disabled={isSubmitting || disabled}
                type="submit"
              >
                {stringAddAnother}
              </button>
              {/* if we require at least one experience, force them to submit one */}
              {/* if they filled the 2nd or later entry at all, also validate/submit that */}
              {(!numExperiencesAdded || !areTextInputsEmpty(values)) ? (
                <button
                  className="alt_button"
                  disabled={isSubmitting || disabled}
                  onClick={setNoMore}
                  type="submit"
                >
                  {stringNoMore}
                </button>
              ) : (
                // hard continue button, no form shenanigans
                <button
                  className="alt_button"
                  disabled={isSubmitting || disabled}
                  onClick={onContinue}
                  type="button"
                >
                  {stringNoMore}
                </button>
              )}
            </div>
          </form>
        );
      }}
    </Formik>
  );
}

WorkExperienceForm.propTypes = {
  disabled: PropTypes.bool,
  handleFormSubmit: PropTypes.func.isRequired,
  numExperiencesAdded: PropTypes.number.isRequired,
  overrideInitialValues: PropTypes.object,
  onContinue: PropTypes.func.isRequired,
  setAddAnother: PropTypes.func.isRequired,
  setNoMore: PropTypes.func.isRequired,
  stringAddAnother: PropTypes.string,
  stringNoMore: PropTypes.string,
  enableRichText: PropTypes.bool,
  enableReinitialize: PropTypes.bool,
};

WorkExperienceForm.defaultProps = {
  disabled: false,
  overrideInitialValues: initialValues,
  stringAddAnother: STRING_SCREEN_ADD_ANOTHER,
  stringNoMore: STRING_SCREEN_NO_MORE,
  enableRichText: false,
  enableReinitialize: false,
};
